module.exports = __webpack_public_path__ + "img/covid-table-03.9a30842f.png";